import Vue from 'vue'
import BScroll from 'better-scroll'
Vue.mixin({
  computed: {},
  data() {
    return {}
  },
  methods: {

  },
  mounted() {
    this.$nextTick(() => {
      if (this.$refs.myTable) {
        console.log(this.$refs.myTable)
        const bs = new BScroll('.el-table_1_body-wrapper', {
          mouseWheel: true,
          scrollbar: true
          // and so on
        })
        console.log(bs)
      }
    })
  }
})